/* ============================================================
   GLOBAL BASE JS
   assets/yc-base.js
   ============================================================ */

/* ══ GLOBAL ADD TO CART ══ */
(function () {
  'use strict';

  function updateBadge(count) {
    ['yc-cart-badge', 'yc-cart-badge-mobile'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) { el.textContent = count; el.style.display = count > 0 ? 'flex' : 'none'; }
    });
  }

  function openSideCart() {
    if (typeof window.ycOpenCart === 'function') {
      window.ycOpenCart();
    } else {
      var t = document.getElementById('yc-cart-open');
      if (t) t.click();
      else {
        var tm = document.getElementById('yc-cart-open-mobile');
        if (tm) tm.click();
      }
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.mcf__atc, .yc-bs__atc');
    if (!btn || btn.disabled) return;

    var vid = parseInt(btn.dataset.vid, 10);
    if (!vid) return;

    var original = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1 })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('failed');
      return r.json();
    })
    .then(function () {
      btn.textContent = 'Added ✓';
      openSideCart();
      return fetch('/cart.js');
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      updateBadge(cart.item_count);
      setTimeout(function () {
        btn.textContent = original;
        btn.disabled = false;
      }, 1500);
    })
    .catch(function () {
      btn.textContent = original;
      btn.disabled = false;
    });
  });

})();


/* ══ WISHLIST ══ */
(function () {
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem('yc_wishlist') || '[]'); } catch (e) { return []; }
  }
  function saveWishlist(list) { localStorage.setItem('yc_wishlist', JSON.stringify(list)); }

  function initWishBtns() {
    document.querySelectorAll('.mcf__wish-btn').forEach(function (btn) {
      var handle = btn.dataset.handle;
      if (getWishlist().indexOf(handle) !== -1) btn.classList.add('is-wishlisted');
      if (btn._wishInit) return;
      btn._wishInit = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var list = getWishlist();
        var idx  = list.indexOf(handle);
        if (idx === -1) { list.push(handle); btn.classList.add('is-wishlisted'); }
        else { list.splice(idx, 1); btn.classList.remove('is-wishlisted'); }
        saveWishlist(list);
      });
    });
  }

  initWishBtns();
  document.addEventListener('click', function () {
    setTimeout(initWishBtns, 300);
  });
})();